import dayjs from "dayjs";
import objectSupport from "dayjs/plugin/objectSupport";
import { ISO_FORMAT } from "../../DatePicker/constants";
dayjs.extend(objectSupport);
var currentYearJune = function currentYearJune(year) {
  return dayjs({
    year: year,
    month: 5,
    // June is month 5 in dayjs (0-indexed)
    day: 30,
    hour: 0,
    second: 0
  });
};
var currentYearJuly = function currentYearJuly(year) {
  return dayjs({
    year: year,
    month: 6,
    // July is month 6 in dayjs (0-indexed)
    day: 1,
    hour: 0,
    second: 0
  });
};
export function determineThisFinancialYear(toOrFrom) {
  var currentTime = dayjs();
  if (toOrFrom === "from") {
    if (currentYearJuly(currentTime.year()) > currentTime) {
      return currentYearJuly(currentTime.year()).subtract({
        year: 1
      }).format(ISO_FORMAT);
    }
    return currentYearJuly(currentTime.year()).format(ISO_FORMAT);
  }
  if (toOrFrom === "to") {
    if (currentYearJune(currentTime.year()) < currentTime) {
      return currentYearJune(currentTime.year()).add({
        year: 1
      }).format(ISO_FORMAT);
    }
    return currentYearJune(currentTime.year()).format(ISO_FORMAT);
  }
  return null;
}
export function determineLastFinancialYear(toOrFrom) {
  var currentTime = dayjs();
  if (toOrFrom === "from") {
    if (currentYearJuly(currentTime.year()) > currentTime) {
      return currentYearJuly(currentTime.year()).subtract({
        year: 2
      }).format(ISO_FORMAT);
    }
    return currentYearJuly(currentTime.year()).subtract({
      year: 1
    }).format(ISO_FORMAT);
  }
  if (toOrFrom === "to") {
    if (currentYearJune(currentTime.year()) > currentTime) {
      return currentYearJune(currentTime.year()).subtract({
        year: 1
      }).format(ISO_FORMAT);
    }
    return currentYearJune(currentTime.year()).format(ISO_FORMAT);
  }
  return null;
}